<template>
  <div class="active__filters">
    <div class="active__filter">
      <div class="active__filter__header">Ubicación</div>
      <div @mouseover="showVersion=true" @mouseleave="showVersion=false" class="active__filter__body">
        {{ filter.ubication }}
      </div>
      <div @mouseover="showVersion=true" @mouseleave="showVersion=false" v-show="showVersion && (aqlFilter.version ? aqlFilter.version.length : 0)" class="active__filter__body--out-box">
        <p :key="version" v-for="version in aqlFilter.version" class="active__filter__body--out-box__text">
          {{ countryName(version) }}
        </p>
      </div>
    </div>

    <div class="active__filter">
      <div class="active__filter__header">Sector</div>
      <div @mouseover="showSector=true" @mouseleave="showSector=false" class="active__filter__body">
        {{ filter.sector }}
      </div>
      <div @mouseover="showSector=true" @mouseleave="showSector=false" v-show="showSector && (aqlFilter.sector ? aqlFilter.sector.length : 0)" class="active__filter__body--out-box--sector">
        <span :key="sector" v-for="sector in aqlFilter.sector" class="active__filter__body--out-box__text--sector">
          {{ sector }}
        </span>
      </div>
    </div>

    <div class="active__filter">
      <div class="active__filter__header">Persona</div>
      <div @mouseover="showKindOfPerson=true" @mouseleave="showKindOfPerson=false" class="active__filter__body">
        {{ filter.person }}
      </div>
      <div @mouseover="showKindOfPerson=true" @mouseleave="showKindOfPerson=false" v-show="showKindOfPerson && (aqlFilter.kindOfPerson ? aqlFilter.kindOfPerson.length : 0)" class="active__filter__body--out-box">
        <p :key="kindOfPerson" v-for="kindOfPerson in aqlFilter.kindOfPerson" class="active__filter__body--out-box__text">
          {{ person(kindOfPerson) }}
        </p>
      </div>
    </div>

    <div class="active__filter">
      <div class="active__filter__header">Antig&#252;edad en Alegra</div>
      <div class="active__filter__body">{{ filter.months }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveFilter',
  data () {
    return {
      showVersion: false,
      showSector: false,
      showKindOfPerson: false
    }
  },
  computed: {
    aqlFilter () {
      return this.$store.getters.aqlFilter
    },
    filter () {
      const { version, sector, kindOfPerson } = this.aqlFilter
      const { opts: { time: { months } } } = this.$store.getters.filter

      return {
        ubication: version ? `(${version.length} ${version.length === 1 ? 'país' : 'países'})` : '-',
        sector: sector ? `(${sector.length} ${sector.length === 1 ? 'sector' : 'sectores'})` : '-',
        person: kindOfPerson ? this.person(kindOfPerson[0]) : '-',
        months: months.show ? months.key : '-'
      }
    }
  },
  methods: {
    person (kindOfPerson) {
      return kindOfPerson === '1' ? 'Jurídica' : 'Natural'
    },
    countryName (name) {
      if (name === 'costaRica') {
        return 'Costa Rica'
      } else if (name === 'republicaDominicana') {
        return 'Republica Dominicana'
      } else if (name === 'spain') {
        return 'España'
      } else if (name === 'usa') {
        return 'Estados Unidos'
      } else if (name === 'other') {
        return 'Otros'
      } else if (name === 'mexico') {
        return 'México'
      } else if (name === 'peru') {
        return 'Perú'
      } else if (name === 'panama') {
        return 'Panamá'
      } else {
        return name[0].toUpperCase() + name.slice(1)
      }
    }
  }
}
</script>

<style>
  .active__filters {
    align-items: flex-start;
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-bottom: 20px;
    max-width: 724px;
    position: absolute;
    width: calc(100% - 300px);
  }

  .active__filter {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
  }

  .active__filter__header {
    color: #00535e;
    font-size: 12px;
    font-weight: 400;
    text-align: center;

    width: fit-content;
  }

  .active__filter__body {
    color: #00535e;
    font-size: 13px;
    font-weight: bold;
    text-align: center;

    border-color: #cccccc;
    border-radius: 20px;
    border-style: solid;
    border-width: 1px;
    width: 140px;
  }

  .active__filter__body--out-box {
    font-weight: bold;
    font-size: 7px;
    text-align: justify;

    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    padding: 5px 10px;
    position: absolute;
    top: 40px;
  }

  .active__filter__body--out-box--sector {
    font-weight: bold;
    font-size: 7px;

    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 2px 5px rgba(0,0,0,0.2);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 5px 10px;
    position: absolute;
    top: 40px;
    width: 425px;
  }

  .active__filter__body--out-box__text {
    color: #707070;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 17px;
  }

  .active__filter__body--out-box__text--sector {
    color: #707070;
    font-family: Roboto;
    font-size: 12px;
    font-weight: 400;
    letter-spacing: 0;
    line-height: 17px;
    text-align: left;

    width: 200px;
  }
</style>
